module.exports = __webpack_public_path__ + "images/emoji/leaves.478abfadd794d3626a3f.png";